import { render, staticRenderFns } from "./CalendarFrame.vue?vue&type=template&id=3e6ce668"
import script from "./CalendarFrame.vue?vue&type=script&lang=js"
export * from "./CalendarFrame.vue?vue&type=script&lang=js"
import style0 from "./CalendarFrame.vue?vue&type=style&index=0&id=3e6ce668&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports